import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { Button, LoadingSpinner } from "src/components/generic";
import { TextInputWithRegister } from "src/components/inputs";
import { useAuth } from "src/context/AuthContext";
import { ToastStatus, useToast } from "src/context/ToastContext";
import { auth, informativ } from "src/utils";
import { userTypes } from "src/utils/types";

const ResetPasswordForm: FunctionComponent = () => {
  const mp = process.env.REACT_APP_CV_MASTER_ID;
  const { user, tokens } = useAuth();
  const { setToast } = useToast();
  const { register, handleSubmit } = useForm({
    defaultValues: {
      oldPassword: "",
      newPassword: "",
    },
  });

  const submit = async (data: any) => {
    try {
      const { oldPassword, newPassword } = data;
      if (
        !user ||
        !tokens ||
        !tokens.accessToken ||
        !oldPassword ||
        !newPassword ||
        !mp
      )
        return console.log({ user, tokens, oldPassword, newPassword, mp }); //error toast

      const informativResult =
        await informativ.creditUsers.changeCreditPassword(
          {
            uid:
              user.userType === userTypes.AccountTypes.OWNER ? mp : user.userId,
            cus_id: user.metadata.cus_id,
          },
          oldPassword,
          newPassword
        );

      // const cognitoResult = await auth.cognito.resetPassword(
      //   tokens.accessToken,
      //   oldPassword,
      //   newPassword
      // );ClientVitals410!

      console.log({ informativResult });

      setToast({
        message: "Password reset complete",
        status: ToastStatus.SUCCESS,
      });
    } catch (error: any) {
      setToast({
        message: "Password Reset Failed",
        status: ToastStatus.FAIL,
      });
    }
  };

  if (!user) return <LoadingSpinner />;
  return (
    <form>
      <TextInputWithRegister
        id="Old Password"
        register={register("oldPassword")}
        placeholder={"current Password"}
        password
      />

      <TextInputWithRegister
        id="New Password"
        register={register("newPassword")}
        placeholder={"new Password"}
        password
        showPasswordToggle
      />
      <Button styles="mt-4" text="Save" onClick={handleSubmit(submit)} />
    </form>
  );
};

export default ResetPasswordForm;
